export default [
    'exe',
    'dll',
    'msi',
    'docm',
    'ppt',
    'xls',
    'dot',
    'docx',
    'doc',
    'pptx',
    'pptm',
    'xlsx',
    'xlsm',
    'docx',
    'docm',
    'rtf',
    'html',
    'pdf',
    'exe/dll',
    'ocx/dll',
    'exe/dll/ocx',
    'jar',
    'hwp',
    'dotx',
    'dotm',
    'msg',
    'mso',
    'pps',
    'ppsx',
    'ppsm',
    'pot',
    'potx',
    'potm',
    'ppam',
    'xlsb',
    'xlm',
    'xlt',
    'xltx',
    'xltm',
    'xla',
    'xlam',
    'xll',
    'xlw',
    'sldx',
    'sldm',
    'iqy',
    'url',
    'swf',
    'hta',
    'mht',
    'mhtml',
    'deb',
    'elf',
    'sh',
    'bat',
    'vbs',
    'vbe',
    'wsf',
    'wsc',
    'js',
    'jse',
    'ps1',
    'psc1',
    'psm1',
    'chm',
    'lnk',
    'cpl',
    'scr',
    'py',
    'pyc',
    'pyo',
];
